export default (uri, isOpenInNewWindow) => window.Core.openURI(uri, isOpenInNewWindow);
